import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';

import {CoreCommonModule} from '@core/common.module';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {ImageCropperModule} from 'ngx-image-cropper';
import {SharedModule} from '../../shared/shared.module';
import {QuillModule} from 'ngx-quill';

import {PartnersComponent} from './partners.component';
import {AddPartnerComponent} from './add-partner/add-partner.component';
import {PartnerDetailShellComponent} from './partner-detail-shell/partner-detail-shell.component';
import {PartnerLeadsComponent} from './partner-leads/partner-leads.component';
import {PaiuTransactionComponent} from '../paiu-transaction/paiu-transaction.component';
import {PartnerLinkedUniversitiesComponent} from './partner-linked-universities/partner-linked-universities.component';
import {PartnerCoursesComponent} from './partner-courses/partner-courses.component';

const routes: Routes = [
    {
        path: 'partner',
        component: PartnersComponent,
        data: {animation: 'partner'}
    },
    {
        path: 'partner/:slug',
        component: PartnerDetailShellComponent,
        data: {animation: 'partner'},
        children: [
            {path: '', redirectTo: 'universities', pathMatch: 'full'},
            {path: 'universities', component: PartnerLinkedUniversitiesComponent},
            {path: 'courses', component: PartnerCoursesComponent},
            {path: 'leads', component: PartnerLeadsComponent},
            {path: 'paiu-transaction', component: PaiuTransactionComponent}
        ]
    }
];

@NgModule({
    declarations: [
        PartnersComponent,
        AddPartnerComponent,
        PartnerDetailShellComponent,
        PartnerLinkedUniversitiesComponent,
        PartnerCoursesComponent,
        PartnerLeadsComponent
    ],
    imports: [
        CommonModule,
        CoreCommonModule,
        RouterModule.forChild(routes),
        CoreSidebarModule,
        NgbPaginationModule,
        ImageCropperModule,
        SharedModule,
        QuillModule
    ],
    exports: [
        PartnersComponent,
        AddPartnerComponent,
        PartnerDetailShellComponent,
        PartnerLinkedUniversitiesComponent,
        PartnerCoursesComponent,
        PartnerLeadsComponent
    ]
})
export class PartnersModule {
}
